import { Box, Skeleton as MuiSkeleton, Stack } from '@mui/material';
import { PAGE_MAX_WIDTH } from 'components/pages/insights/constants';
import { memo } from 'react';

const CollectionCardSkeleton = () => (
  <Box sx={{ flex: { xs: '0 0 167px', lg: '1 1 0' }, minWidth: 0 }}>
    <MuiSkeleton variant="rounded" sx={{ width: '100%', height: { xs: 140, lg: 200 }, mb: 2 }} />
    <MuiSkeleton variant="rounded" sx={{ width: '70%', height: 16, mb: 1 }} />
    <MuiSkeleton variant="rounded" sx={{ width: '40%', height: 12 }} />
  </Box>
);

const HorizontalCardSkeleton = () => (
  <Box sx={{ display: 'flex', gap: { xs: 5, lg: 6 } }}>
    <MuiSkeleton
      variant="rounded"
      sx={{ width: { xs: 92, lg: 185 }, height: { xs: 94, lg: 152 }, flexShrink: 0, borderRadius: '12px' }}
    />
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2 }}>
      <MuiSkeleton variant="rounded" sx={{ width: 80, height: { xs: 24, lg: 28 }, borderRadius: '48px' }} />
      <MuiSkeleton variant="rounded" sx={{ width: '80%', height: { xs: 16, lg: 18 } }} />
      <MuiSkeleton variant="rounded" sx={{ width: 60, height: { xs: 12, lg: 14 } }} />
    </Box>
  </Box>
);

export const BookmarksSkeleton = memo(() => (
  <Box
    sx={{
      maxWidth: { xs: 'none', lg: PAGE_MAX_WIDTH },
      mx: { xs: 0, lg: 'auto' },
      px: { xs: 5, lg: 0 },
      py: { xs: 3, lg: 5 },
    }}
  >
    <MuiSkeleton variant="circular" sx={{ display: { xs: 'block', lg: 'none' }, width: 36, height: 36, mb: 2 }} />
    <MuiSkeleton
      variant="rounded"
      sx={{ display: { xs: 'none', lg: 'block' }, width: 80, height: 32, borderRadius: '40px', mb: 1 }}
    />

    <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', lg: 'center' }, mb: { xs: 6, lg: 8 } }}>
      <MuiSkeleton variant="rounded" sx={{ width: { xs: 160, lg: 240 }, height: { xs: 30, lg: 44 } }} />
    </Box>

    <Stack gap={{ xs: 10, lg: 18 }}>
      <Box>
        <MuiSkeleton variant="rounded" sx={{ width: 120, height: 22, mb: 4 }} />
        <Box sx={{ display: 'flex', gap: { xs: 2, lg: 6 }, overflow: 'hidden' }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <CollectionCardSkeleton key={i} />
          ))}
        </Box>
      </Box>

      <Box>
        <MuiSkeleton variant="rounded" sx={{ width: 80, height: 22, mb: 4 }} />
        <Stack gap={{ xs: 4, lg: 6 }} sx={{ mt: 4 }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <HorizontalCardSkeleton key={i} />
          ))}
        </Stack>
      </Box>
    </Stack>
  </Box>
));
